import { IOptionalDateWindow } from '@/types/datetimes';
import { TypographyProps } from '@mui/material';

import { TentativeDateDisplay } from '../dates/CommonDateDisplays';
import { OptionalDateFulfillmentWindowDisplay } from '../fulfillmentWindows/OptionalDateFulfillmentWindowDisplay';
import { NoneLabel } from '../labels/NoneLabel';

export const VisitRequestDateTypeDisplay = ({
    label = true,
    tentativeDate,
    fulfillmentWindow,
    dateProps = {},
}: {
    label?: boolean;
    tentativeDate: Date | null;
    fulfillmentWindow: IOptionalDateWindow | null;
    dateProps?: TypographyProps;
}) => {
    if (tentativeDate) {
        return (
            <TentativeDateDisplay
                tentativeDate={tentativeDate}
                label={label}
                dateProps={dateProps}
            />
        );
    }
    if (fulfillmentWindow) {
        return (
            <OptionalDateFulfillmentWindowDisplay
                fulfillmentWindow={fulfillmentWindow}
                label={label}
                dateProps={dateProps}
            />
        );
    }
    return <NoneLabel {...dateProps} />;
};
